import styles from "../styles/dialogue.module.css";
import Layout from '../components/Layout';
import { useDashboardList } from 'hooks/dashboardHooks';
import CreateDashboardModal from 'components/Dashboard/CreateDashboradModal';
// import Chat from "components/Chat"
import ChatWithAlignedSidebar from "components/Chat/ChatWithAlignedSidebar";

const ChatWindowAlt = () => {

  useDashboardList();

  return (
    <Layout>
      <div className={styles.newDialog}>
        {/* <Chat /> */}
        <ChatWithAlignedSidebar />
      </div>

      <CreateDashboardModal />
    </Layout>
  );
};

export default ChatWindowAlt;